import "./Footer.css";
import { Link } from "react-router-dom";
import rxConnectLogo from "../../assets/rxconnectlogo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-company">
          <img
            src={rxConnectLogo}
            alt="Rx Connect Specialty Pharmacy logo"
            className="footer-logo"
          />
          <h3>
            <a
              href="https://www.rxconnect.ca/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-brand-link"
            >
              Rx Connect Specialty Pharmacy
            </a>
          </h3>
          <p className="footer-label">Business Address</p>
          <p>
            6990 Creditview Road, Unit 4
            <br />
            Mississauga, Ontario
            <br />
            L5N 8R9
          </p>
        </div>

        <div className="footer-contact">
          <h4>Contact</h4>
          <p>
            Email:{" "}
            <a href="mailto:pharmacy@rxconnect.ca">pharmacy@rxconnect.ca</a>
          </p>
          <p>
            Phone: <a href="tel:18556922738">1.855.692.2738</a>
          </p>
        </div>

        <div className="footer-links">
          <h4>Legal</h4>
          <ul>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-of-use">Terms of Use</Link>
            </li>
            <li>
              <Link to="/complaints">Complaints Process</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-divider" />
      <p className="footer-regulatory">
        <a href="https://www.rxconnect.ca/" target="_blank" rel="noopener noreferrer">
          Rx Connect Specialty Pharmacy
        </a>{" "}
        operates under the regulations of the Ontario College of Pharmacists.
      </p>
      <p className="footer-ownership">
        This website is owned and operated by{" "}
        <a href="https://www.rxconnect.ca/" target="_blank" rel="noopener noreferrer">
          Rx Connect Specialty Pharmacy
        </a>.
      </p>
      <p className="footer-disclaimer">
        The information on this page is for informational purposes only and does
        not constitute medical advice. Please consult a healthcare professional
        for medical guidance.
      </p>
      <div className="footer-bottom">
        © {new Date().getFullYear()}{" "}
        <a href="https://www.rxconnect.ca/" target="_blank" rel="noopener noreferrer">
          Rx Connect Specialty Pharmacy
        </a>
        . All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
